module.exports = __webpack_public_path__ + "static/media/vn.a62ad62f.svg";